const amka = [
    { type: 'required', message: 'Social Security Number is required' },
    { type: 'minlength', message: 'Social Security Number must be at exactly characters long' },
    { type: 'maxlength', message: 'Social Security Number must be at exactly characters long' },
    { type: 'pattern', message: 'Your social security number must contain only numbers and letters' },
]

export default { amka };